/* eslint-disable-next-line */
import React, { useState, useEffect, useRef } from 'react';
import './style.css';
import T from 'i18n-react';
import MessageEntry from './messageEntry';
import { useSelector, useDispatch } from 'react-redux';
import MessagesUnavailable from './messagesUnavailable';
import MessageInputEditor from './MessageInputEditor';
import MessagesActions from '../../reducers/messagesRedux';
import { HeapEvents, trackEvent } from '../../utils/AnalyticsUtil';
import { isValidMessage } from '../Register/services/registrationUtils';

const MessagesView = (props) => {
    const dispatch = useDispatch();
    const [dashboardTab, setDashboardTab] = useState(props.dashboardTab)
    const [messageContent, setMessageContent] = useState([])
    const [hasPreviousBlockMessages, setHasPreviousBlockMessages] = useState(false)
    const [messagesLoaded] = useState(props.messagesLoaded);
    const [validationError, setValidationError] = useState(null);

    const messageInProgress = useSelector(state => state.messages.messageInProgress);
    const messageSendState = useSelector(state => state.messages.messageSendState);

    const enabled = useSelector(state => {
        if (state.workflow && state.workflow.case_state && state.workflow.case_state.taxYears) {
            if (state.workflow.case_state.taxYears.some(ty => ty.assigned_tax_pro)) {
                return true
            }
        }
        return false
    })

    useEffect(() => {
        props.updateLastReadMessages();
    }, [])

    useEffect(() => {
        if (dashboardTab !== props.dashboardTab) {
            setDashboardTab(props.dashboardTab)
        }
    }, [props.dashboardTab, dashboardTab])

    const handleMessageChange = (content) => {
        dispatch(MessagesActions.setMessageInProgress(content));
        if (validationError) {
            setValidationError(null);
        }
    }

    const validateMessageContent = (message) => {
        const temp = document.createElement('div');
        temp.innerHTML = message;
        const textContent = temp.textContent || temp.innerText || '';
        var plainText = textContent.trim();
        if (!plainText || plainText.length === 0) {
            return { valid: false, error: T.translate("Common.Errors.InvalidNameChars") };
        }
        if (!isValidMessage(plainText)) {
            return { valid: false, error: T.translate("Common.Errors.InvalidNameChars") };
        }
        return { valid: true, error: null };
    }

    const handleSendMessage = () => {
        const validation = validateMessageContent(messageInProgress);
        if (!validation.valid) {
            if (validation.error) {
                setValidationError(validation.error);
            }
            return;
        }
        var stateMessage = messageInProgress.replace(/<[^>]*>?/gm, '');
        if (stateMessage && stateMessage.trim().length > 0) {
            setValidationError(null);
            dispatch(MessagesActions.setMessageSendState('sending'));
            trackEvent(HeapEvents.BTN_SEND_MESSAGE);
        }
    }

    // Clear editor after successful send
    useEffect(() => {
        if (messageSendState === 'complete') {
            dispatch(MessagesActions.setMessageInProgress(''));
            setTimeout(() => {
                dispatch(MessagesActions.setMessageSendState(''));
            }, 1000);
        }
    }, [messageSendState]);

    const AlwaysScrollToBottom = () => {
        const delayRef = useRef()
        const elementRef = useRef();
        useEffect(() => {
            if(messagesLoaded) {
                delayRef.current = setTimeout(() => {
                    if(elementRef.current) {
                        elementRef.current.scrollIntoView({ block: "end", behavior: "smooth" })
                    }
                }, 1000)
            }
            return () => {
                clearTimeout(elementRef.current)
            }
        });
        return <div ref={elementRef} />;
    };

    useEffect(() => {
        var hbm = false
        var mc = [];
        for (var i = 0; i < props.messages.length; ++i) {
            var message = props.messages[i]
            if (message.isBlockComment) {
                hbm = true
            }
            mc.push(
                <MessageEntry key={'message_' + i} messageText={message.commentText} lang={props.lang}
                    isNew={message.isBlockComment && (message.isNew)}
                    isBlockMessage={message.isBlockComment} labelText={props.initials}
                    timestamp={message.createdDate} />)
        }
        setMessageContent(mc)
        if (hasPreviousBlockMessages !== hbm) {
            setHasPreviousBlockMessages(hbm)
        }
    }, [props.messages, props.unreadMessagesCount, props.lang])

    return (
        <div className={["messageViewMain", props.visible ? "showing" : "hiding"].join(' ')}>
            {!enabled &&
                <MessagesUnavailable hasPrevious={hasPreviousBlockMessages}
                    showDivider={(props.messages || []).length > 0} layoutType={props.layoutType} />
            }
            <div className="messageViewContent" id="messagesScrollParent">
                <div className="messageViewScrollContent">
                    {messageContent}
                    <AlwaysScrollToBottom />
                </div>
            </div>
            {enabled && (
                <div className="messageInputContainerWF">
                    <MessageInputEditor
                        onInputChanged={handleMessageChange}
                        messageContent={messageInProgress}
                        visible={props.visible}
                        disabled={!enabled}
                        onSend={handleSendMessage}
                    />
                    {validationError && (
                        <div className="message-validation-error">
                            {validationError}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}


export default MessagesView;
